import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import { resetPassword } from '../core/_requests'
import axios from 'axios'
import { KTIcon } from '../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL

const initialValues = {
  firstPassword: '',
  password: '',

}

const resetPasswordSchema = Yup.object().shape({
  firstPassword: Yup.string().required('Contraseña es requerida'),
  password: Yup.string().required('Confirmación de Contraseña es requerida'),
})

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [hasValidLink, setHasValidLink] = useState<boolean | undefined>(undefined)

  const [showFirstPassword, setShowFirstPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [passwordMatch, setPasswordMatch] = useState<boolean | undefined>(undefined);

  const [showLinkLogin, setShowLinkLogin] = useState(false);

  const toggleFirstPasswordVisibility = () => {
    setShowFirstPassword(!showFirstPassword);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      const searchParams = new URLSearchParams(location.search);
      const usuarioId = searchParams.get('u');
      setTimeout(() => {
        resetPassword(usuarioId!, values.password)
          .then(({ data: { result } }) => {
            setHasErrors(false)
            setLoading(false)
            setShowLinkLogin(true);
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const usuarioId = searchParams.get('u');
    const correo = searchParams.get('p');

    // Verificar si se han obtenido los parámetros de usuarioId y correo
    if (usuarioId && correo) {
      // Construir el cuerpo de la solicitud
      const body = { usuarioId, correo };

      // Realizar la solicitud al servicio usando Axios
      axios.post(`${API_URL}/recuperacion_contrasenia/validar`, body)
        .then(response => {
          // Manejar la respuesta del servicio
          console.log(response.data);
          setHasValidLink(true);
        })
        .catch(error => {
          // Manejar errores de la solicitud
          console.error('Error:', error);
          setHasValidLink(false);
        });
    }
  }, [location.search]);

  useEffect(() => {
    // Verificar si ambos campos tienen valores y compararlos
    if (formik.values.firstPassword && formik.values.password) {
      setPasswordMatch(formik.values.firstPassword === formik.values.password);
    }
  }, [formik.values.firstPassword, formik.values.password]);


  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      {showLinkLogin}
      {(hasValidLink === true) ? (
        <>

          <div className='text-center mb-5'>
            {/* begin::Title */}
            <h1 className='text-dark fw-bolder mb-3'>Reestablecer Contraseña</h1>
            {/* end::Title */}

            {/* begin::Link */}
            {/* <div className='text-gray-500 fw-semibold fs-6'>
          Ingresa contraseña nueva y confirma ingresando de nuevo.
        </div> */}
            {/* end::Link */}
          </div>

          {/* begin::Title */}
          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                Lo siento, detectamos un error, intente de nuevo.
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='alert alert-info text-center'>
              <div>Contraseña reestablecida, intente iniciar sesión</div>
            </div>
          )}
          {/* end::Title */}

          {showLinkLogin ?
            (<>
              <Link to='/auth/login'>
                <div className='d-flex flex-row justify-content-center'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-primary'
                  >
                    Iniciar Sesión
                  </button>
                </div>
              </Link>{' '}
            </>)
            :
            (
              <>
                <div className={passwordMatch === true ? 'alert alert-success text-center' : passwordMatch === false ? 'alert alert-danger text-center' : ''}>
                  {passwordMatch === true ? 'Contraseña Confirmada' : passwordMatch === false ? 'No coinciden las contraseñas' : ''}
                </div>

                {/* begin::Form group */}
                <div className='fv-row mb-8'>
                  <div className='form-floating'>
                    <input
                      type={showFirstPassword ? 'text' : 'password'} placeholder='Contraseña'
                      autoComplete='off'
                      {...formik.getFieldProps('firstPassword')}
                      className={clsx(
                        'form-control bg-transparent',
                        { 'is-invalid': formik.touched.firstPassword && formik.errors.firstPassword },
                        {
                          'is-valid': formik.touched.firstPassword && !formik.errors.firstPassword,
                        }
                      )}
                    />
                    <label htmlFor='firstPassword'>Contraseña</label>
                    <div className="position-absolute end-0 top-50 translate-middle-y pointer me-10" onClick={toggleFirstPasswordVisibility}>
                      {showFirstPassword ?
                        <KTIcon iconName='eye-slash' className=' fs-1' /> :
                        <KTIcon iconName='eye' className=' fs-1' />}
                    </div>
                  </div>
                  {/* <label className='form-label fw-bolder text-gray-900 fs-6'>Correo</label> */}

                  {formik.touched.firstPassword && formik.errors.firstPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.firstPassword}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-8'>
                  <div className='form-floating'>
                    {/* <label className='form-label fw-bolder text-gray-900 fs-6'>Correo</label> */}
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder='Confirmar Contraseña'
                      autoComplete='off'
                      {...formik.getFieldProps('password')}
                      className={clsx(
                        'form-control bg-transparent',
                        { 'is-invalid': formik.touched.password && formik.errors.password },
                        {
                          'is-valid': formik.touched.password && !formik.errors.password,
                        }
                      )}
                    />
                    <label htmlFor='firstPassword'>Confirmar Contraseña</label>
                    <div className="position-absolute end-0 top-50 translate-middle-y pointer me-10" onClick={togglePasswordVisibility}>
                      {showPassword ?
                        <KTIcon iconName='eye-slash' className=' fs-1' /> :
                        <KTIcon iconName='eye' className=' fs-1' />}
                    </div>
                  </div>
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn btn-primary me-4'
                    disabled={formik.isSubmitting || !formik.isValid || !formik.touched}>
                    <span className='indicator-label'>Reestablecer</span>
                    {loading && (
                      <span className='indicator-progress'>
                        Reestableciendo...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <Link to='/auth/login'>
                    <button
                      type='button'
                      id='kt_login_password_reset_form_cancel_button'
                      className='btn btn-light'
                      disabled={formik.isSubmitting || !formik.isValid}
                    >
                      Cancelar
                    </button>
                  </Link>{' '}
                </div>
              </>
            )
          }

        </>
      ) : hasValidLink === false ? (
        <>
          <div className='text-center mb-5'>
            <h1 className='fw-bolder'>Error con la Solicitud</h1>
          </div>
          <div className='text-gray-500 fw-semibold fs-6 px-7 mb-3'>
            Reintente de nuevo el proceso de recuperación, si el problema persiste hable con el administrador.
          </div>
          <h1 className='text-center mb-3'>⚠️</h1>
          <Link to='/auth/login'>
            <div className='d-flex flex-row justify-content-center'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-primary'
              >
                Iniciar Sesión
              </button>
            </div>
          </Link>{' '}
        </>
      ) : ''
      }
      {/* end::Form group */}
    </form>
  )
}
